import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Camera, Thermometer, Droplets, Waves, Flame, Battery } from 'lucide-react';
export function Facilities() {
  const facilities = [{
    icon: <Camera size={24} data-id="element-92" />,
    title: 'High-Speed Camera System',
    description: 'Phantom high-speed cameras for capturing rapid thermal-fluid events'
  }, {
    icon: <Thermometer size={24} data-id="element-93" />,
    title: 'Infrared Thermography',
    description: 'FLIR thermal imaging systems for non-contact temperature measurement'
  }, {
    icon: <Droplets size={24} data-id="element-94" />,
    title: 'Spray Cooling Test Rig',
    description: 'Custom-designed experimental setup for spray cooling studies'
  }, {
    icon: <Waves size={24} data-id="element-95" />,
    title: 'Microchannel Flow Boiling Setup',
    description: 'Precision test section for flow boiling experiments'
  }, {
    icon: <Flame size={24} data-id="element-96" />,
    title: 'Heat Pipe Testing Facility',
    description: 'Comprehensive characterization setup for heat pipes and vapor chambers'
  }, {
    icon: <Battery size={24} data-id="element-97" />,
    title: 'Battery Thermal Test Bench',
    description: 'Dedicated facility for lithium-ion cell thermal management studies'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="equipment" className="py-24 bg-[#FAF9F7]" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-100">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl md:text-4xl font-bold text-[#800000] font-serif mb-4" data-id="element-101">
            Facilities & Equipment
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-102">
            State-of-the-art infrastructure for cutting-edge thermal research
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-103">
          {facilities.map((facility, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow group" data-id="element-104">
              <div className="w-12 h-12 bg-[#800000]/5 rounded-lg flex items-center justify-center text-[#800000] mb-4 group-hover:bg-[#800000] group-hover:text-white transition-colors" data-id="element-105">
                {facility.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 font-serif" data-id="element-106">
                {facility.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-107">
                {facility.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}